export const addFavoriteLabel = "VmRKsd";
export const hideFavoritesLabel = "bD18Gd";
export const newFavoritePickedText = "z4Grzc";
export const renameFavoriteLabel = "qpB7De";
export default {addFavoriteLabel,hideFavoritesLabel,newFavoritePickedText,renameFavoriteLabel};